import { createRegistry, type RegistryEntry } from '@ayocore/platform/client/extensions/createRegistry';

/** Ссылка на отчёт в разделе «Отчёты» CRM. */
export interface CrmReportLink extends RegistryEntry {
  /** Код отчёта — уникален в пределах раздела. */
  code: string;
  /** Подпись в списке. */
  label: string;
  /** Адрес страницы отчёта. Может вести в другой модуль — это нормально. */
  url: string;
  /** Порядок в списке (меньше — выше). По умолчанию — в конец. */
  order?: number;
}

/**
 * Реестр отчётов раздела «Отчёты» CRM.
 *
 * Свои отчёты сюда кладёт сама CRM, а модули и инстансы — свои, не трогая её
 * код. Отчёт при этом остаётся целиком у владельца: url, страница и логика
 * живут там, где зарегистрированы; CRM заимствует только строчку в списке.
 *
 * Реестр, а не слот: отчёт — сущность с кодом, а не кусок конкретного экрана.
 * По коду его можно найти и перезаписать, а список читается откуда угодно —
 * сейчас со страницы раздела, завтра, например, из поиска.
 */
export const CrmReportsRegistry = createRegistry<CrmReportLink>('crm-reports');

/** Отчёты раздела, отсортированные для показа. */
export function getCrmReportLinks(): CrmReportLink[] {
  return [...CrmReportsRegistry.getAll()].sort(
    (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER)
  );
}
